import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiairporttogoacab() {



    const cardData = {

keyword: "Navi Mumbai Airport to Goa Cabs",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai Airport to Goa Cabs for long-distance travel, holiday trips, group tours, family vacations, corporate travel, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup from Navi Mumbai Airport, and safe highway driving through the scenic Mumbai–Goa route, we ensure a smooth, comfortable, and hassle-free travel experience to Goa.",

topPlaces: [
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of Goa’s most popular beaches known for water sports, nightlife, beach shacks, and vibrant tourist activity."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach is a famous tourist destination in North Goa known for its long coastline, shopping stalls, and beach activities."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "The Basilica of Bom Jesus is a UNESCO World Heritage Site in Old Goa known for its baroque architecture and sacred religious importance."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a well-preserved Portuguese fort offering panoramic sea views and a historic lighthouse overlooking the Arabian Sea."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is known for its rocky shoreline, flea market, nightlife, and relaxed hippie vibe popular among tourists."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India’s tallest waterfalls located on the Goa–Karnataka border, famous for its milky cascading water."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach in South Goa is known for its calm waters, scenic beauty, and peaceful environment ideal for relaxation."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort offers stunning views of Vagator Beach and became famous from Bollywood films, attracting photography lovers."
    },
    {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia known for its Portuguese-Gothic architecture and historical significance."
    },
    {
        title: "Mapusa Market",
        description:
            "Mapusa Market is a bustling local market in Goa offering spices, handicrafts, clothes, and authentic Goan products."
    }
],



services: [
{
name: "Mumbai to Goa Cab",
description: "Mumbai to Goa Cab service by 1Touch Cabs offers safe, comfortable, and reliable long-distance travel for families, tourists, corporate travellers, and group trips. We provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller with professional chauffeurs experienced in highway driving. Whether it is a one-way trip, round trip, or holiday travel, we ensure smooth rides, punctual pickup, luggage assistance, and a stress-free journey. With 24x7 availability, transparent pricing, and easy online booking, we make Mumbai to Goa road travel convenient, affordable, and enjoyable."
},
{
name: "Mumbai to Goa Taxi Fare",
description: "Mumbai to Goa Taxi Fare with 1Touch Cabs is transparent, competitive, and suitable for all travel budgets. We offer flexible pricing for Sedan, SUV, Innova, Innova Crysta, and premium vehicles based on travel type, distance, and route preference. Our fares include professional chauffeur service, clean vehicles, and comfortable long-distance travel. With no hidden charges and clear billing, passengers enjoy a reliable and cost-effective journey to Goa."
},
{
name: "Mumbai to Goa Taxi",
description: "Mumbai to Goa Taxi service provides convenient and safe transportation for leisure trips, family vacations, and business travel. 1Touch Cabs ensures well-maintained air-conditioned vehicles, experienced chauffeurs, and smooth highway travel. We focus on comfort, punctuality, and customer satisfaction, making long journeys enjoyable and stress-free."
},
{
name: "Mumbai to Goa Cab Fare",
description: "Mumbai to Goa Cab Fare by 1Touch Cabs is designed to offer affordable and transparent pricing for all types of travellers. Whether you choose a budget sedan or a luxury SUV, we provide clear fare structures without hidden charges. Our service includes professional drivers, clean vehicles, and reliable long-distance travel experience."
},
{
name: "Mumbai to Goa Taxi One Way Fare",
description: "Mumbai to Goa Taxi One Way Fare service offers economical transportation for travellers who need a direct drop to Goa. 1Touch Cabs provides flexible one-way pricing, comfortable vehicles, and experienced chauffeurs for safe highway travel. Ideal for solo travellers, families, and tourists seeking budget-friendly long-distance rides."
},
{
name: "Mumbai to Goa Cab Price",
description: "Mumbai to Goa Cab Price service ensures competitive and transparent pricing for all categories of vehicles. 1Touch Cabs offers Sedan, SUV, Innova, and premium cab options with affordable rates for one-way and round-trip journeys. We guarantee comfortable travel, professional service, and no hidden costs."
},
{
name: "Mumbai to Goa By Car Fare",
description: "Mumbai to Goa By Car Fare service provides clear cost estimates for road travel between Mumbai and Goa based on vehicle type and travel requirements. 1Touch Cabs ensures budget-friendly pricing, comfortable rides, and professional chauffeur service for a smooth journey experience."
},
{
name: "Mumbai Airport to Goa Cab",
description: "Mumbai Airport to Goa Cab service offers direct long-distance transfers from Mumbai Airport to Goa with professional chauffeurs and comfortable vehicles. 1Touch Cabs provides flight tracking, luggage assistance, and smooth highway travel for arriving passengers heading to Goa."
},
{
name: "Mumbai Goa Cab Service",
description: "Mumbai Goa Cab Service by 1Touch Cabs ensures reliable intercity transportation for holidays, business trips, and family vacations. We offer a wide range of vehicles, experienced drivers, and 24x7 availability for a seamless travel experience between Mumbai and Goa."
},
{
name: "Mumbai to Goa Cab Booking",
description: "Mumbai to Goa Cab Booking service allows customers to reserve long-distance taxis easily through online or offline booking. 1Touch Cabs provides instant confirmation, flexible travel options, transparent pricing, and professional chauffeur service for a smooth journey experience."
},
{
name: "Mumbai to Goa Cab Charges",
description: "Mumbai to Goa Cab Charges with 1Touch Cabs are transparent, competitive, and based on vehicle type and travel preference. We ensure fair pricing with no hidden costs, offering affordable long-distance travel for all categories of passengers."
},
{
name: "Mumbai to Goa Car Hire",
description: "Mumbai to Goa Car Hire service provides flexible rental options for leisure, business, and family travel. 1Touch Cabs offers clean vehicles, experienced chauffeurs, and customizable travel packages for a comfortable road trip to Goa."
},
{
name: "Mumbai to Goa Taxi Price",
description: "Mumbai to Goa Taxi Price service ensures clear and affordable fare options for different vehicle types and travel needs. 1Touch Cabs provides reliable service, professional drivers, and comfortable travel experiences at competitive rates."
},
{
name: "Navi Mumbai Airport to Goa Cabs",
description: "Navi Mumbai Airport to Goa Cabs service offers direct and comfortable airport-to-Goa transportation with experienced chauffeurs and clean vehicles. 1Touch Cabs ensures timely pickups, smooth highway travel, and reliable long-distance service for arriving passengers."
},
{
name: "Navi Mumbai Airport to Goa Cab",
description: "Navi Mumbai Airport to Goa Cab service provides safe and convenient transportation from airport terminals to Goa destinations. 1Touch Cabs offers professional drivers, luggage assistance, and comfortable vehicles for stress-free travel."
},
{
name: "Navi Mumbai Airport to Goa Taxi",
description: "Navi Mumbai Airport to Goa Taxi service ensures reliable and punctual long-distance travel for passengers arriving at the airport. 1Touch Cabs provides clean vehicles, experienced chauffeurs, and smooth highway journeys."
},
{
name: "Cab from Navi Mumbai Airport to Goa",
description: "Cab from Navi Mumbai Airport to Goa service offers direct intercity travel with professional chauffeurs and comfortable vehicles. 1Touch Cabs ensures timely pickup, safe driving, and hassle-free long-distance transportation."
},
{
name: "Taxi from Navi Mumbai Airport to Goa",
description: "Taxi from Navi Mumbai Airport to Goa service provides convenient and reliable transportation for tourists, families, and corporate travellers. 1Touch Cabs ensures smooth travel, transparent pricing, and 24x7 availability."
},
{
name: "Book Cab Navi Mumbai Airport to Goa",
description: "Book Cab Navi Mumbai Airport to Goa service allows customers to quickly reserve long-distance airport transfers with instant confirmation. 1Touch Cabs provides flexible booking options, professional chauffeurs, and comfortable vehicles."
},
{
name: "Online Cab Booking Navi Mumbai Airport to Goa",
description: "Online Cab Booking Navi Mumbai Airport to Goa service provides a fast and easy way to book intercity travel. 1Touch Cabs ensures transparent pricing, multiple vehicle options, and reliable service for a smooth journey experience."
},
{
name: "Best Cab Navi Mumbai Airport to Goa",
description: "Best Cab Navi Mumbai Airport to Goa service by 1Touch Cabs ensures premium travel quality with clean vehicles, experienced drivers, and safe highway journeys. We focus on comfort, punctuality, and customer satisfaction."
},
{
name: "Cheapest Cab Navi Mumbai Airport to Goa",
description: "Cheapest Cab Navi Mumbai Airport to Goa service offers budget-friendly long-distance travel without compromising safety or comfort. 1Touch Cabs provides affordable pricing, reliable chauffeurs, and well-maintained vehicles."
},
{
name: "Reliable Taxi Navi Mumbai Airport to Goa",
description: "Reliable Taxi Navi Mumbai Airport to Goa service ensures safe, punctual, and comfortable transportation for all types of travellers. 1Touch Cabs guarantees professional chauffeurs, clean vehicles, and dependable long-distance service."
}
],

tableData: [
["Mumbai to Goa Cab","Mumbai to Goa Taxi Fare"],
["Mumbai to Goa Taxi","Mumbai to Goa Cab Fare"],
["Mumbai to Goa Taxi One Way Fare","Mumbai to Goa Cab Price"],
["Mumbai to Goa By Car Fare","Mumbai Airport to Goa Cab"],
["Mumbai Goa Cab Service","Mumbai to Goa Cab Booking"],
["Mumbai to Goa Cab Charges","Mumbai to Goa Car Hire"],
["Mumbai to Goa Taxi Price","Navi Mumbai Airport to Goa Cabs"],
["Navi Mumbai Airport to Goa Cab","Navi Mumbai Airport to Goa Taxi"],
["Cab from Navi Mumbai Airport to Goa","Taxi from Navi Mumbai Airport to Goa"],
["Book Cab Navi Mumbai Airport to Goa","Online Cab Booking Navi Mumbai Airport to Goa"],
["Best Cab Navi Mumbai Airport to Goa","Cheapest Cab Navi Mumbai Airport to Goa"],
["Reliable Taxi Navi Mumbai Airport to Goa","Mumbai to Goa Cab"]
],











whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai Airport to Goa Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai Airport to Goa Cab services for tourists, families, couples, corporate travelers, and vacationers seeking comfortable long-distance transportation."
    },
    {
        WhyChooseheading: "Direct Airport to Goa Travel Solution",
        WhyChoosedescription: "Passengers arriving at Navi Mumbai Airport can enjoy hassle-free direct transportation to Goa without changing flights, trains, buses, or multiple travel modes."
    },
    {
        WhyChooseheading: "Perfect for Holidays and Beach Vacations",
        WhyChoosedescription: "Goa is India's most popular holiday destination, famous for its beaches, nightlife, water sports, churches, forts, seafood, and scenic coastal beauty."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way airport transfer, round trip, family vacation package, or customized Goa tour, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Flight Tracking and Timely Pickup",
        WhyChoosedescription: "Our team monitors flight schedules and adjusts pickup timings accordingly to ensure smooth airport transfers even during flight delays."
    },
    {
        WhyChooseheading: "Experienced Drivers for Long-Distance Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced on Mumbai-Goa highway routes and ensure safe, comfortable, and stress-free transportation."
    },
    {
        WhyChooseheading: "Ideal for Families, Couples, and Groups",
        WhyChoosedescription: "From honeymoon couples and families to corporate teams and tourist groups, we provide suitable vehicles for every Goa travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Navi Mumbai Airport to Goa Cabs?",
        answer: "Many travelers prefer direct cab transportation for comfort, flexibility, sightseeing opportunities, family vacations, and hassle-free travel."
    },
    {
        question: "Can I book a one-way cab from Navi Mumbai Airport to Goa?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Goa travel packages."
    },
    {
        question: "Which vehicle is suitable for Navi Mumbai Airport to Goa travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and luggage requirements."
    },
    {
        question: "Do you provide airport pickup from Navi Mumbai Airport?",
        answer: "Yes, pickup services are available from all operational terminals at Navi Mumbai Airport."
    },
    {
        question: "Can families book airport cabs for Goa vacations?",
        answer: "Yes, many families choose our airport cab services for comfortable and convenient travel directly to Goa hotels, resorts, villas, and beaches."
    },
    {
        question: "Are Tempo Travellers available for group Goa trips?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, bachelor trips, corporate outings, and tourist groups."
    },
    {
        question: "Will the driver wait if my flight is delayed?",
        answer: "Yes, flight schedules are monitored and pickup timings are adjusted according to actual arrival times."
    },
    {
        question: "Can sightseeing places be included during the Goa trip?",
        answer: "Yes, customers can customize their itinerary and visit North Goa, South Goa, beaches, forts, churches, casinos, waterfalls, and other attractions."
    },
    {
        question: "Is advance booking recommended for Navi Mumbai Airport to Goa travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle, especially during weekends, holidays, Christmas, New Year, and peak tourist seasons."
    },
    {
        question: "How can I book a Navi Mumbai Airport to Goa Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Abhishek Mehra",
        feedback:
            "After arriving at Navi Mumbai Airport, we traveled directly to Goa with Mumbai Airport Cabs. The vehicle was comfortable, the driver was professional, and the journey was extremely enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Richa Kulkarni",
        feedback:
            "We booked a family Goa vacation package and were highly satisfied with the service. The cab was spacious, clean, and the entire trip was managed professionally from start to finish.",
        rating: 5
    }
];
























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Goa Cabs",
  "image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-airport-to-goa-cab.jpg",
  "description": "Book Navi Mumbai Airport to Goa cabs for comfortable long-distance travel with professional chauffeurs. Mumbai Airport Cabs offers safe, reliable, and affordable outstation taxi service from Mumbai Airport to Goa with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10,999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/navi-mumbai-airport-to-goa-cabs"
  }
};




    return (
        <div>



<Helmet>
  <title>Navi Mumbai Airport to Goa Cabs | Mumbai to Goa Taxi Service | +91 9545731161</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport to Goa cabs for safe and comfortable outstation travel. Affordable Mumbai to Goa taxi service with professional drivers and 24x7 booking support."
  />

  <meta
    name="keywords"
    content="mumbai to goa cab, mumbai to goa taxi fare, mumbai to goa taxi, mumbai to goa cab fare, mumbai to goa taxi one way fare, mumbai to goa cab price, mumbai to goa by car fare, mumbai airport to goa cab, mumbai goa cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaiairporttogoacab;